<template>
  <div v-show="isActive">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      required: true
    },
    selected: {
      default: false
    },
    width: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      isActive: false
    }
  },
  mounted() {
    this.isActive = this.selected
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/tabs/Tab.vue